/**
 * Keyboard layouts (pure data, no three.js import so tests can load it under Node).
 * Only glyphs present in the Roboto MSDF atlas may appear: it lacks < > ^ and the backtick.
 */
export type KeyDef = {
  label: string;
  input?: string;
  command?: 'shift' | 'backspace' | 'space' | 'enter' | 'symbols';
  width?: number;
};

const chars = (s: string): KeyDef[] => s.split('').map((c) => ({ label: c, input: c }));

export const ROWS_LETTERS: KeyDef[][] = [
  chars('1234567890'),
  chars('qwertyuiop'),
  [...chars('asdfghjkl'), { label: 'del', command: 'backspace', width: 1.5 }],
  [{ label: 'shift', command: 'shift', width: 1.5 }, ...chars('zxcvbnm'), ...chars('.-')],
  [
    { label: '#+=', command: 'symbols', width: 1.5 },
    { label: 'space', command: 'space', width: 5 },
    { label: '@', input: '@' },
    { label: 'enter', command: 'enter', width: 2 },
  ],
];

export const ROWS_SYMBOLS: KeyDef[][] = [
  chars('1234567890'),
  chars('!@#$%&*()='),
  [...chars('-_+[]{};:'), { label: 'del', command: 'backspace', width: 1.5 }],
  [{ label: 'shift', command: 'shift', width: 1.5 }, ...chars('\'",/?\\|~.')],
  [
    { label: 'abc', command: 'symbols', width: 1.5 },
    { label: 'space', command: 'space', width: 5 },
    { label: '.', input: '.' },
    { label: 'enter', command: 'enter', width: 2 },
  ],
];
